import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import RankingTrendOliveyoung from "./pages/cosmeticRank/rankingTrendOliveyoung";
import RankingTrendCommerce from "./pages/cosmeticRank/rankingTrendCommerce";
import RealCommerceRankingTrend from "./pages/cosmeticRank/realCommerceRankigTrend";
import MainPage from "./pages/main";


function AppRouter() {
  return (
    <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={
              <MainPage />
          } /> */}

          <Route path="/" element={
              <App />
          }>
            <Route index element={<MainPage />} />
            <Route path="/dashboard/rank-trend-o" element={
              <RankingTrendOliveyoung />
            } />
            <Route path="/dashboard/real-category-rank-trend" element={
              <RealCommerceRankingTrend />
            } />
            <Route path="/dashboard/rank-trend-commerce" element={
              <RankingTrendCommerce />
            } />
          </Route>
        </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;